<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 18 18">
  <g clip-path="url(#a)">
    <path d="M14.25 12.705v-6.33c0-2.093-1.957-2.55-4.508-2.618l.57-1.132h2.438V1.5h-7.5v1.125h3.563l-.57 1.14c-2.348.067-4.493.533-4.493 2.61v6.33c0 1.088.893 1.995 1.942 2.227L4.5 16.125v.375h1.673l1.5-1.5H10.5l1.5 1.5h1.5v-.375L12.375 15h-.06c1.268 0 1.935-1.027 1.935-2.295ZM9 13.875a1.123 1.123 0 0 1-1.125-1.125c0-.623.502-1.125 1.125-1.125s1.125.502 1.125 1.125S9.623 13.875 9 13.875Zm3.75-3.375h-7.5V6.75h7.5v3.75Z"/>
  </g>
  <defs>
    <clipPath id="a">
      <path d="M0 0h18v18H0z"/>
    </clipPath>
  </defs>
</svg>
